import {
  ICountryAPIResponseItem,
  IGetExchangesAPIResponseItem,
  IGetPointsOfSaleCategoriesAPIResponseItem,
} from 'api/endpoints/general/general.response.interface';
import { TFunction } from 'i18next';

export interface InitialGeneralState {
  ping: boolean;
  setPing: (value: boolean) => void;
  isLoadingSetPing: boolean;
  exchanges: Array<IGetExchangesAPIResponseItem>;
  countries: Array<ICountryAPIResponseItem>;
  associationStates: IAssociationsStates | null;
  isLoadingPointsOfSaleCategories: boolean;
  pointsOfSaleCategories: Array<IGetPointsOfSaleCategoriesAPIResponseItem>;
}

export const pending = 'pending';
export const connected = 'connected';
export const rejected = 'rejected';
export const disconnected = 'disconnected';
export const matching = 'matching';

export interface IAssociation {
  id: string;
  state: string;
}

export interface IAssociationsStates {
  pending: IAssociation;
  connected: IAssociation;
  rejected: IAssociation;
  disconnected: IAssociation;
}

export interface IChildrenProps {
  children: React.ReactNode;
}

// GENERAL INTERFACES ////////////////
export interface IResponseAPI {
  response: Response;
}

export type ITranslate = TFunction<'translation', undefined>;
//////////////////////////////////////
